import React from 'react'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import { ListItem } from 'material-ui/List'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import Divider from 'muicss/lib/react/divider'
import Avatar from '../../../BadgeHeroesComponents/Avatar'
import { selectCampaign } from '../../../../actions'

const styles = {
  campaign: enable => ({
    cursor: 'pointer',
    // backgroundColor: '#ffffff',
    fontWeight: 'bold',
    padding: '10px',
    textAlign: 'center',
    opacity: enable ? 1 : 0.5,
  }),
  image: {
    height: '100px',
    width: 'auto',
  },
  campaignPercentage: {
    color: 'gray',
    fontSize: '1.5em',
  },
  content: {
    borderRadius: '10px',
    padding: '10px',
    border: '1px solid #efefef',
    minHeight: '200px',
    textAlign: 'center',
  },
  image_content: {
    textAlign: 'center',
  },
  description: {
    fontSize: '13px',
    color: 'rgba(0, 0, 0, 0.54)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  tittle: {
    fontSize: '15px',
  },
  listItem: {
    marginLeft: '40px',
    marginRight: '40px',
  },
  listItemText: {
    marginTop: '10px',
    marginLeft: '40px',
    marginRight: '40px',
  },
  colorPercent: {
    color: '#f2881d',
  },
  disable: {
    backgroundColor: 'red',
    height: '100px',
    borderRadius: '100px',
  },
  imageEnable: {
    height: '100px',
    width: 'auto',
  },
  imageDisable: {
    height: '100px',
    width: 'auto',
    filter: 'brightness(20%)',
  },
  lock: {
    fontSize: 22,
    float: 'right',
    padding: 10,
    color: 'gray',
  },
  check: {
    fontSize: 22,
    float: 'right',
    padding: 10,
    color: '#aad361',
  },
  lockShort: {
    color: 'gray',
  },
  checkShort: {
    color: '#aad361',
  },
  timer: {
    backgroundColor: 'gray',
    borderRadius: 100,
    color: 'white',
    fontSize: '12px',
    textAlign: 'center',
  },
}

/*
<ListItem
  style={style}
  innerDivStyle={style}
  nestedListStyle={style}
  leftAvatar={<Avatar size={60} image_url={image_url} />}
  primaryText={
    <div
      className="mui--text-headline" style={style}
    > {`${first_name} ${last_name}`} </div>
  }
  secondaryText={
    <div
      className="mui--text-headline" style={style}
    > {team !== null ? `${team.name}` : ''} </div>
  }
  secondaryTextLines={2}
/>
*/
class Campaign extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      timer: '',
    }
  }

  componentDidMount() {
    this.timerInterval = setInterval(() => this._setTimer(), 1000)
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval)
  }

  onClick() {
    if (this.isEnable()) {
      this.props.selectCampaign(this.props)
    }
  }

  _setTimer() {
    // Get todays date and time
    const maxTimer = new Date((this.props.end_date || '').replace('+0000', '')).getTime()
    const now = new Date().getTime()

    // Find the distance between now an the count down date
    const distance = maxTimer - now

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

    // Display the result in the element with id="demo"
    let text = `${days}d ${hours}h ${minutes}m ${seconds}s `

    // If the count down is finished, write some text
    if (distance < 0) {
      text = 'EXPIRED'
    }

    this.setState({ timer: text })
  }

  isBonus() {
    return (
      this.props.hierarchy_type === 1
      && (this.props.completed_missions !== this.props.total_missions)
    )
  }

  isSoftEnable() {
    return (
      !this.props.hierarchy ||
      this.props.isAllParentsCampaignsCompleted
    )
  }

  isEnable() {
    return (
      this.props.campaignState !== 2 && this.isSoftEnable()
    )
  }

  isLock() {
    return (
      this.isSoftEnable() && this.props.campaignState === 2
    )
  }

  shortMode() {
    const { name, image_url, completed_missions,
      total_missions } = this.props
    return (
      <Row
        style={styles.campaign(this.isEnable())} onClick={() => this.onClick()}
      >
        { this.renderTimer() }
        <Col>
          <img
            style={this.isEnable() ? styles.imageEnable : styles.imageDisable}
            alt={name}
            src={image_url}
          />
        </Col>
        <Col>
          <Row style={styles.tittle}>
            {(name || '').substring(0, 20) + ((name || '').length > 20 ? '...' : '')}
          </Row>
          <Row style={styles.campaignPercentage} >
            { this.isLock() &&
              [<FontAwesome
                name="lock"
                style={styles.lockShort}
              />, ' ']
            }
            { completed_missions === total_missions &&
              [<FontAwesome
                name="check-circle"
                style={styles.checkShort}
              />, ' ']
            }
            {
              this.isLock()
              ? 'No disponible'
              : `${completed_missions}/${total_missions}`
            }
          </Row>
        </Col>
      </Row>
    )
  }

  largeMode() {
    const { name, image_url, description, completed_missions,
      total_missions } = this.props
    return (
      <Row
        style={{ opacity: this.isEnable() ? 1 : 0.5 }}
        className="mui--align-middle"
        onClick={() => this.onClick()}
      >
        {
          this.isBonus()
          ? (
            <div style={{ padding: 5, paddingLeft: 20, paddingRight: 20 }}>
              { this.renderTimer() }
            </div>
          )
          : null
        }
        <ListItem
          style={styles.listItem}
          innerDivStyle={styles.listItem}
          nestedListStyle={styles.listItem}
          leftAvatar={
            <Avatar
              style={this.isEnable() ? {} : { filter: 'brightness(20%)' }}
              size={80}
              image_url={image_url}
            />
          }
          primaryText={
            <div
              className="mui--text-headline" style={styles.listItemText}
            >
              {
                this.isLock() && <FontAwesome
                  name="lock"
                  style={styles.lock}
                />
              }
              { completed_missions === total_missions &&
                <FontAwesome
                  name="check-circle"
                  style={styles.check}
                />
              }
              <span>{`${name} `}</span>
              <span style={styles.colorPercent}>{completed_missions}/{total_missions}</span>
            </div>
          }
          secondaryText={
            <div>
              <div style={styles.listItem}>
                {description || name}
              </div>
            </div>
          }
          secondaryTextLines={2}
        />
        <Divider />
      </Row>
    )
  }

  renderTimer() {
    if (!this.isBonus()) { return null }
    return (
      <Col style={styles.timer}>
        {this.state.timer}
      </Col>
    )
  }

  render() {
    if (this.props.fullmode) {
      return this.largeMode()
    }
    return this.shortMode()
  }
}

Campaign.propTypes = {
  end_date: React.PropTypes.string,
  hierarchy_type: React.PropTypes.number,
  campaignState: React.PropTypes.number,
  hierarchy: React.PropTypes.bool,
  isAllParentsCampaignsCompleted: React.PropTypes.bool,
  name: React.PropTypes.string,
  image_url: React.PropTypes.string,
  completed_missions: React.PropTypes.number,
  total_missions: React.PropTypes.number,
  selectCampaign: React.PropTypes.func,
  fullmode: React.PropTypes.bool,
  description: React.PropTypes.string,
}

const mapStateToProps = state => ({ state })

const mapDispatchToProps = dispatch => ({
  selectCampaign: campaign => dispatch(selectCampaign(campaign)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Campaign)



// WEBPACK FOOTER //
// ./src/components/Main/Campaigns/Campaign/index.jsx